import React from "react";
import { Modal, StyleSheet, Text, View } from "react-native";
import BlacklistedLeader from "../../assets/svg/BlacklistedLeader";
import BackButton from "../BackButton";

import t from "@constants/localization";

const PATH = "components/LGL/BlackListedModal";

const BlackListedModal = (props) => {
  const { navigation, blacklisted = false } = props;

  return (
    <Modal visible={blacklisted}>
      <View style={{ backgroundColor: "white" }}>
        <HeaderWithBackAndTitle
          navigation={navigation}
          name={t(`${PATH}/blockedDirector`)}
        />
      </View>
      <View style={styles.body}>
        <BlacklistedLeader />
        <Text
          style={{
            fontFamily: "NotoSansDevanagari-Bold",
            fontSize: 16,
            marginTop: 20,
            marginBottom: 5,
          }}
        >
          {t(`${PATH}/youreBlackListed`)}
        </Text>
        <Text
          style={{
            fontFamily: "NotoSansDevanagari-Regular",
            textAlign: "center",
          }}
        >
          {t(`${PATH}/contactSupport`)}
        </Text>
      </View>
    </Modal>
  );
};

export default BlackListedModal;

const styles = StyleSheet.create({
  body: {
    justifyContent: "center",
    flex: 1,
    alignItems: "center",
  },
});

const HeaderWithBackAndTitle = ({ navigation, name = "" }) => (
  <View
    style={{
      paddingVertical: 13,
      flexDirection: "row",
      alignItems: "center",
      borderBottomColor: "rgba(28,28,28, 0.1)",
      //   borderBottomWidth: 1,
    }}
  >
    <BackButton onPress={navigation.goBack} />
    <Text
      style={{
        fontFamily: "NotoSansDevanagari-Bold",
        color: "black",
        fontSize: 20,
        marginLeft: 20,
        marginRight: 13,
      }}
    >
      {name}
    </Text>
  </View>
);
